// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.enterprise-users-report {
  padding: 2rem;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  min-height: 100vh;
}

.report-header {
  background: white;
  border-radius: 15px;
  padding: 2rem;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
  margin-bottom: 2rem;
}

.report-header h2 {
  color: #2d3748;
  font-weight: 700;
}

.stat-card {
  background: white;
  border-radius: 12px;
  padding: 1.5rem;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.08);
  display: flex;
  align-items: center;
  gap: 1rem;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.stat-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);
}

.stat-icon {
  width: 60px;
  height: 60px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 1.5rem;
}

.stat-icon.bg-primary {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
}

.stat-icon.bg-success {
  background: linear-gradient(135deg, #56ab2f 0%, #a8e063 100%);
}

.stat-icon.bg-danger {
  background: linear-gradient(135deg, #eb3349 0%, #f45c43 100%);
}

.stat-icon.bg-info {
  background: linear-gradient(135deg, #2196f3 0%, #21cbf3 100%);
}

.stat-content {
  flex: 1 1;
}

.stat-value {
  font-size: 2rem;
  font-weight: 700;
  color: #2d3748;
  line-height: 1;
  margin-bottom: 0.25rem;
}

.stat-label {
  font-size: 0.875rem;
  color: #718096;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.filters-section {
  background: #f8f9fa;
  border-radius: 10px;
  padding: 1.5rem;
  border: 1px solid #e2e8f0;
}

.filters-section .form-label {
  font-weight: 600;
  color: #4a5568;
  font-size: 0.875rem;
  margin-bottom: 0.5rem;
}

.filters-section .form-control,
.filters-section .form-select {
  border-radius: 8px;
  border: 1px solid #cbd5e0;
  padding: 0.625rem 0.875rem;
  font-size: 0.9rem;
}

.filters-section .form-control:focus,
.filters-section .form-select:focus {
  border-color: #667eea;
  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
}

.filters-section .input-group-text {
  background: white;
  border: 1px solid #cbd5e0;
  border-right: none;
  color: #718096;
}

.table-container {
  background: white;
  border-radius: 15px;
  overflow-x: auto;
  overflow-y: visible;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
}

.table-container table {
  margin-bottom: 0;
  min-width: 1400px;
  table-layout: fixed;
  width: 100%;
}

/* Header colors come from Bootstrap's .table-dark on the thead (app-wide
   standard) — a background set here on the thead element is painted over by
   the th cells' own --bs-table-bg, leaving white text unreadable. */
.table-container thead th {
  border: none;
  padding: 0.75rem 0.5rem;
  font-weight: 600;
  text-transform: uppercase;
  font-size: 0.75rem;
  letter-spacing: 0.5px;
  white-space: nowrap;
}

.table-container tbody td {
  padding: 0.75rem 0.5rem;
  vertical-align: middle;
  border-bottom: 1px solid #e2e8f0;
  font-size: 0.85rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* Column widths */
.table-container th:nth-child(1),
.table-container td:nth-child(1) {
  width: 100px; /* Employee ID */
}

.table-container th:nth-child(2),
.table-container td:nth-child(2) {
  width: 180px; /* Display Name */
  white-space: normal;
}

.table-container th:nth-child(3),
.table-container td:nth-child(3) {
  width: 200px; /* Email */
}

.table-container th:nth-child(4),
.table-container td:nth-child(4) {
  width: 150px; /* Job Title */
}

.table-container th:nth-child(5),
.table-container td:nth-child(5) {
  width: 120px; /* Department */
}

.table-container th:nth-child(6),
.table-container td:nth-child(6) {
  width: 100px; /* Manager ID */
}

.table-container th:nth-child(7),
.table-container td:nth-child(7) {
  width: 150px; /* Manager Name */
  white-space: normal;
}

.table-container th:nth-child(8),
.table-container td:nth-child(8) {
  width: 100px; /* Status */
  text-align: center;
}

.table-container tbody tr:last-child td {
  border-bottom: none;
}

.table-container tbody tr:hover {
  background-color: #f7fafc;
}

.table-container .badge {
  padding: 0.375rem 0.75rem;
  font-weight: 500;
  font-size: 0.75rem;
  border-radius: 6px;
}

.btn-success {
  background: linear-gradient(135deg, #56ab2f 0%, #a8e063 100%);
  border: none;
  padding: 0.625rem 1.5rem;
  font-weight: 600;
  border-radius: 8px;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.btn-success:hover {
  transform: translateY(-2px);
  box-shadow: 0 5px 15px rgba(86, 171, 47, 0.4);
}

.btn-outline-secondary {
  border-radius: 8px;
  font-weight: 600;
  border: 2px solid #cbd5e0;
  color: #4a5568;
}

.btn-outline-secondary:hover {
  background-color: #4a5568;
  border-color: #4a5568;
  color: white;
}

/* Loading and empty states */
.spinner-border {
  width: 3rem;
  height: 3rem;
}

.text-muted {
  color: #718096 !important;
}

/* Scrollbar styling */
.table-container::-webkit-scrollbar {
  height: 8px;
}

.table-container::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 10px;
}

.table-container::-webkit-scrollbar-thumb {
  background: #888;
  border-radius: 10px;
}

.table-container::-webkit-scrollbar-thumb:hover {
  background: #555;
}

/* Pagination styling */
.pagination-container {
  background: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(10px);
  border-radius: 12px;
  padding: 1rem 1.5rem;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.pagination-container .pagination {
  gap: 0.25rem;
}

.pagination-container .page-item .page-link {
  background: white;
  border: 2px solid rgba(255, 255, 255, 0.3);
  color: #667eea;
  font-weight: 600;
  padding: 0.5rem 0.75rem;
  border-radius: 8px;
  transition: all 0.2s ease;
  margin: 0 0.125rem;
}

.pagination-container .page-item .page-link:hover:not(:disabled) {
  background: #667eea;
  color: white;
  border-color: #667eea;
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(102, 126, 234, 0.3);
}

.pagination-container .page-item.active .page-link {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-color: #667eea;
  color: white;
  box-shadow: 0 4px 8px rgba(102, 126, 234, 0.4);
}

.pagination-container .page-item.disabled .page-link {
  background: rgba(255, 255, 255, 0.5);
  color: #cbd5e0;
  border-color: rgba(255, 255, 255, 0.3);
  cursor: not-allowed;
}

.pagination-container .form-select-sm {
  border-radius: 8px;
  border: 2px solid rgba(255, 255, 255, 0.3);
  padding: 0.375rem 2rem 0.375rem 0.75rem;
  font-weight: 600;
  color: #667eea;
  background-color: white;
}

.pagination-container .form-select-sm:focus {
  border-color: #667eea;
  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.2);
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .enterprise-users-report {
    padding: 1rem;
  }

  .report-header {
    padding: 1.5rem;
  }

  .stat-card {
    margin-bottom: 1rem;
  }

  .table-container {
    overflow-x: auto;
  }

  .table-container table {
    min-width: 1400px;
  }

  .pagination-container .d-flex {
    flex-direction: column;
    gap: 1rem;
  }

  .pagination-container .pagination {
    justify-content: center;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/EnterpriseUsersReport.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,6DAA6D;EAC7D,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,0CAA0C;EAC1C,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,0CAA0C;EAC1C,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,qDAAqD;AACvD;;AAEA;EACE,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;;EAEE,kBAAkB;EAClB,yBAAyB;EACzB,0BAA0B;EAC1B,iBAAiB;AACnB;;AAEA;;EAEE,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,0CAA0C;AAC5C;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,WAAW;AACb;;AAEA;;oEAEoE;AACpE;EACE,YAAY;EACZ,uBAAuB;EACvB,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,sBAAsB;EACtB,gCAAgC;EAChC,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA,kBAAkB;AAClB;;EAEE,YAAY,EAAE,gBAAgB;AAChC;;AAEA;;EAEE,YAAY,EAAE,iBAAiB;EAC/B,mBAAmB;AACrB;;AAEA;;EAEE,YAAY,EAAE,UAAU;AAC1B;;AAEA;;EAEE,YAAY,EAAE,cAAc;AAC9B;;AAEA;;EAEE,YAAY,EAAE,eAAe;AAC/B;;AAEA;;EAEE,YAAY,EAAE,eAAe;AAC/B;;AAEA;;EAEE,YAAY,EAAE,iBAAiB;EAC/B,mBAAmB;AACrB;;AAEA;;EAEE,YAAY,EAAE,WAAW;EACzB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,wBAAwB;EACxB,gBAAgB;EAChB,kBAAkB;EAClB,qDAAqD;AACvD;;AAEA;EACE,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,YAAY;AACd;;AAEA,6BAA6B;AAC7B;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,sBAAsB;AACtB;EACE,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,uBAAuB;AACvB;EACE,oCAAoC;EACpC,2BAA2B;EAC3B,mBAAmB;EACnB,oBAAoB;EACpB,wCAAwC;AAC1C;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,0CAA0C;EAC1C,cAAc;EACd,gBAAgB;EAChB,uBAAuB;EACvB,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,qBAAqB;EACrB,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,6DAA6D;EAC7D,qBAAqB;EACrB,YAAY;EACZ,8CAA8C;AAChD;;AAEA;EACE,oCAAoC;EACpC,cAAc;EACd,sCAAsC;EACtC,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,0CAA0C;EAC1C,uCAAuC;EACvC,gBAAgB;EAChB,cAAc;EACd,uBAAuB;AACzB;;AAEA;EACE,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA,2BAA2B;AAC3B;EACE;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,uBAAuB;EACzB;AACF","sourcesContent":[".enterprise-users-report {\n  padding: 2rem;\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  min-height: 100vh;\n}\n\n.report-header {\n  background: white;\n  border-radius: 15px;\n  padding: 2rem;\n  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);\n  margin-bottom: 2rem;\n}\n\n.report-header h2 {\n  color: #2d3748;\n  font-weight: 700;\n}\n\n.stat-card {\n  background: white;\n  border-radius: 12px;\n  padding: 1.5rem;\n  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.08);\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n  transition: transform 0.3s ease, box-shadow 0.3s ease;\n}\n\n.stat-card:hover {\n  transform: translateY(-5px);\n  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);\n}\n\n.stat-icon {\n  width: 60px;\n  height: 60px;\n  border-radius: 12px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: white;\n  font-size: 1.5rem;\n}\n\n.stat-icon.bg-primary {\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n}\n\n.stat-icon.bg-success {\n  background: linear-gradient(135deg, #56ab2f 0%, #a8e063 100%);\n}\n\n.stat-icon.bg-danger {\n  background: linear-gradient(135deg, #eb3349 0%, #f45c43 100%);\n}\n\n.stat-icon.bg-info {\n  background: linear-gradient(135deg, #2196f3 0%, #21cbf3 100%);\n}\n\n.stat-content {\n  flex: 1;\n}\n\n.stat-value {\n  font-size: 2rem;\n  font-weight: 700;\n  color: #2d3748;\n  line-height: 1;\n  margin-bottom: 0.25rem;\n}\n\n.stat-label {\n  font-size: 0.875rem;\n  color: #718096;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.filters-section {\n  background: #f8f9fa;\n  border-radius: 10px;\n  padding: 1.5rem;\n  border: 1px solid #e2e8f0;\n}\n\n.filters-section .form-label {\n  font-weight: 600;\n  color: #4a5568;\n  font-size: 0.875rem;\n  margin-bottom: 0.5rem;\n}\n\n.filters-section .form-control,\n.filters-section .form-select {\n  border-radius: 8px;\n  border: 1px solid #cbd5e0;\n  padding: 0.625rem 0.875rem;\n  font-size: 0.9rem;\n}\n\n.filters-section .form-control:focus,\n.filters-section .form-select:focus {\n  border-color: #667eea;\n  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);\n}\n\n.filters-section .input-group-text {\n  background: white;\n  border: 1px solid #cbd5e0;\n  border-right: none;\n  color: #718096;\n}\n\n.table-container {\n  background: white;\n  border-radius: 15px;\n  overflow-x: auto;\n  overflow-y: visible;\n  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);\n}\n\n.table-container table {\n  margin-bottom: 0;\n  min-width: 1400px;\n  table-layout: fixed;\n  width: 100%;\n}\n\n/* Header colors come from Bootstrap's .table-dark on the thead (app-wide\n   standard) — a background set here on the thead element is painted over by\n   the th cells' own --bs-table-bg, leaving white text unreadable. */\n.table-container thead th {\n  border: none;\n  padding: 0.75rem 0.5rem;\n  font-weight: 600;\n  text-transform: uppercase;\n  font-size: 0.75rem;\n  letter-spacing: 0.5px;\n  white-space: nowrap;\n}\n\n.table-container tbody td {\n  padding: 0.75rem 0.5rem;\n  vertical-align: middle;\n  border-bottom: 1px solid #e2e8f0;\n  font-size: 0.85rem;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n/* Column widths */\n.table-container th:nth-child(1),\n.table-container td:nth-child(1) {\n  width: 100px; /* Employee ID */\n}\n\n.table-container th:nth-child(2),\n.table-container td:nth-child(2) {\n  width: 180px; /* Display Name */\n  white-space: normal;\n}\n\n.table-container th:nth-child(3),\n.table-container td:nth-child(3) {\n  width: 200px; /* Email */\n}\n\n.table-container th:nth-child(4),\n.table-container td:nth-child(4) {\n  width: 150px; /* Job Title */\n}\n\n.table-container th:nth-child(5),\n.table-container td:nth-child(5) {\n  width: 120px; /* Department */\n}\n\n.table-container th:nth-child(6),\n.table-container td:nth-child(6) {\n  width: 100px; /* Manager ID */\n}\n\n.table-container th:nth-child(7),\n.table-container td:nth-child(7) {\n  width: 150px; /* Manager Name */\n  white-space: normal;\n}\n\n.table-container th:nth-child(8),\n.table-container td:nth-child(8) {\n  width: 100px; /* Status */\n  text-align: center;\n}\n\n.table-container tbody tr:last-child td {\n  border-bottom: none;\n}\n\n.table-container tbody tr:hover {\n  background-color: #f7fafc;\n}\n\n.table-container .badge {\n  padding: 0.375rem 0.75rem;\n  font-weight: 500;\n  font-size: 0.75rem;\n  border-radius: 6px;\n}\n\n.btn-success {\n  background: linear-gradient(135deg, #56ab2f 0%, #a8e063 100%);\n  border: none;\n  padding: 0.625rem 1.5rem;\n  font-weight: 600;\n  border-radius: 8px;\n  transition: transform 0.2s ease, box-shadow 0.2s ease;\n}\n\n.btn-success:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 5px 15px rgba(86, 171, 47, 0.4);\n}\n\n.btn-outline-secondary {\n  border-radius: 8px;\n  font-weight: 600;\n  border: 2px solid #cbd5e0;\n  color: #4a5568;\n}\n\n.btn-outline-secondary:hover {\n  background-color: #4a5568;\n  border-color: #4a5568;\n  color: white;\n}\n\n/* Loading and empty states */\n.spinner-border {\n  width: 3rem;\n  height: 3rem;\n}\n\n.text-muted {\n  color: #718096 !important;\n}\n\n/* Scrollbar styling */\n.table-container::-webkit-scrollbar {\n  height: 8px;\n}\n\n.table-container::-webkit-scrollbar-track {\n  background: #f1f1f1;\n  border-radius: 10px;\n}\n\n.table-container::-webkit-scrollbar-thumb {\n  background: #888;\n  border-radius: 10px;\n}\n\n.table-container::-webkit-scrollbar-thumb:hover {\n  background: #555;\n}\n\n/* Pagination styling */\n.pagination-container {\n  background: rgba(255, 255, 255, 0.1);\n  backdrop-filter: blur(10px);\n  border-radius: 12px;\n  padding: 1rem 1.5rem;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n}\n\n.pagination-container .pagination {\n  gap: 0.25rem;\n}\n\n.pagination-container .page-item .page-link {\n  background: white;\n  border: 2px solid rgba(255, 255, 255, 0.3);\n  color: #667eea;\n  font-weight: 600;\n  padding: 0.5rem 0.75rem;\n  border-radius: 8px;\n  transition: all 0.2s ease;\n  margin: 0 0.125rem;\n}\n\n.pagination-container .page-item .page-link:hover:not(:disabled) {\n  background: #667eea;\n  color: white;\n  border-color: #667eea;\n  transform: translateY(-2px);\n  box-shadow: 0 4px 8px rgba(102, 126, 234, 0.3);\n}\n\n.pagination-container .page-item.active .page-link {\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  border-color: #667eea;\n  color: white;\n  box-shadow: 0 4px 8px rgba(102, 126, 234, 0.4);\n}\n\n.pagination-container .page-item.disabled .page-link {\n  background: rgba(255, 255, 255, 0.5);\n  color: #cbd5e0;\n  border-color: rgba(255, 255, 255, 0.3);\n  cursor: not-allowed;\n}\n\n.pagination-container .form-select-sm {\n  border-radius: 8px;\n  border: 2px solid rgba(255, 255, 255, 0.3);\n  padding: 0.375rem 2rem 0.375rem 0.75rem;\n  font-weight: 600;\n  color: #667eea;\n  background-color: white;\n}\n\n.pagination-container .form-select-sm:focus {\n  border-color: #667eea;\n  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.2);\n}\n\n/* Responsive adjustments */\n@media (max-width: 768px) {\n  .enterprise-users-report {\n    padding: 1rem;\n  }\n\n  .report-header {\n    padding: 1.5rem;\n  }\n\n  .stat-card {\n    margin-bottom: 1rem;\n  }\n\n  .table-container {\n    overflow-x: auto;\n  }\n\n  .table-container table {\n    min-width: 1400px;\n  }\n\n  .pagination-container .d-flex {\n    flex-direction: column;\n    gap: 1rem;\n  }\n\n  .pagination-container .pagination {\n    justify-content: center;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
